export enum ModalAction {
    Cancel = 'cancel'
    , Proceed = 'proceed'
    , Save = 'save'
    , Close = 'close'
}


// WEBPACK FOOTER //
// ./src/enums/modalaction.enum.ts